import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import ReceiptIcon from '@material-ui/icons/Receipt';
// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

// Components
import PurchaseOrderInfoTable from "./PurchaseOrderInfoTable";
import PurchaseAddItem from "./PurchaseAddItem";
import PurchaseEditShipping from "./PurchaseEditShipping";
//React Router (for getting parameters)
import {  useParams, useHistory } from "react-router-dom";

//number format plugin
import numeral from "numeral";
import { NavLink } from "react-router-dom";

import MessageBox from "../../components/MessageBox/MessageBox";
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import LoadingModal from "../../components/Modal/LoadingModal";
import Preloader from "../../components/Preloader/Preloader";

const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	root: {
		'&$disabled': {
		  color: '#f2f2f2',
		},
	  },
	  disabled: {},
});

const PurchaseOrderReturnInformation = () => {
	const { supid, delivery_date, warehouseid } = useParams();
	const [supplier, setSupplier] = useState(null);
	const [warehouse, setWarehouse] = useState(null);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in PO table
	const [supplierItem, setSupplierItem] = useState(null); //data to display in Add Item dropdown
	
	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [notes, setNotes] = useState('');

	//Message Box
	const [showMsgBox, setShowMsgBox] = useState(false);
	const [msgBoxContent, setMsg] = useState("Empty");
	const [msgType, setMsgType] = useState("success");
	//Message Box EOF

	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);
	const [showModal, setShowModal] = useState(false);

	let history = useHistory();

	const addItem = (item) => {
		let found = items.some(x => x.item_id === item.itemid);
		if(found){
			//if item is existing in itemArray, add the qty instead
			let newItems = items.map((it)=> {
				if(it.item_id === item.itemid){ //add
					it.qty += item.qty;
			  	}
			  return it;
			});
			setItems(newItems);
		}else{
			//add new unique item to array
			setItems([...items, 
				{
				item_id: item.itemid, 
				qty: item.qty,
				price: item.cost, 
				uomDesc: item.uomDesc,
				item_name: item.itemname
				}
			]);
		}	
	}

	const deleteItem = (item_id) => {
		let itemArray = items.filter(item => item.item_id !== item_id);
		setItems(itemArray);
	}

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);
	//update PO total when items update
	useEffect(() => {
		let po_total = 0;
		items.forEach(item => po_total += (item.price*item.qty));
		setPoTotal(po_total);

		if(items.length > 0) {
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [items]);




	const data = async () => {
		//get data for single supplier
		await axios.get(process.env.REACT_APP_API_URL+'get_single_supplier_data', {
			params:{
				supplier_id: supid,  //supplier_id
			}
		}).then((supplier_result)=>{
			setSupplier(supplier_result.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		});
		await axios.get(process.env.REACT_APP_API_URL+'get_single_warehouse_data', {
			params:{
				warehouse_id: warehouseid,  //supplier_id
			}
		}).then((warehouse_result)=>{
			setWarehouse(warehouse_result.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		});
		await axios.get(process.env.REACT_APP_API_URL+'get_supplier_items_list', {
			params:{
				supplier_id: supid,  //supplier_id
				curcode: get_cookies('curcode'),
				jc_u_idno: get_cookies('branchidno'),
			}
		}).then((supplier_item_result)=>{
			setSupplierItem(supplier_item_result.data.data);
		}).catch((error)=>{
			// console.log(error.message);
		});
	};	


	const save_po_return= async () => {
		setShowModal(true); //show loading/please wait modal
		setBtnDisabled(true); // disable button to avoid multiple saves
		const formData = new FormData();
		formData.append("item_array", JSON.stringify(items));
		formData.append("supplier_id", supid);
		formData.append("jc_user_id_no", get_cookies('branchidno'));
		formData.append("curcode", get_cookies('curcode'));
		formData.append("shipping", shipTotal);
		formData.append("trandate", delivery_date);
		formData.append("notes", notes);
		formData.append("jc_username", get_cookies('username'));
		formData.append("warehouse", warehouseid);
	  
		await axios.post(process.env.REACT_APP_API_URL+'save_return_po', formData, {
			headers: {
				'Content-Type': 'multipart/form-data'
				}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Added New PO Return");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/purchases/purchases-order-return-transaction-history');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ReceiptIcon />
				</div>
				<NavLink to={"/purchases"}><h2 style={{color:"black"}}>Purchases</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/purchases/purchases-order-return"}><h2 style={{color:"black"}}>Purchase Order Return</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Purchase Order Return Info</h2>
			</div>
			{supplier && warehouse && supplierItem  ? (			<div className="page-container">
				<LoadingModal showModal={showModal}/>
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={12}>
								<div className={classes.subTitle}>
									Purchase Order Information
								</div>
								<div className={classes.title}>
									{supplier.suppliername || "Supplier Name"}
								</div>
							</Grid>
							{/* <Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
								<PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/>
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
								<PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/>
							</Grid> */}
							<Grid item xs={12} lg={8}>
								<Grid container spacing={3} style={{marginTop:"1.5em",justifyContent: "flex-end"}}>
									<PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/>
									{/* <div style={{marginRight: "0.5em"}}></div> */}
									<PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/>
									<LoadingModal showModal={showModal}/>
								</Grid>
							</Grid>	
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Date of Delivery: 
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{delivery_date || ""}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Deliver To: 
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{warehouse.description || ""}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Branch
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplier.branchidno || "Branch"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2}className={classes.infoTitle}>
									Mode of Payment:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplier.mode_of_payment || "Mode of Payment"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Contact Number:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplier.contactno || "Contact Number"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={12} sm={2} className={classes.infoTitle}>
									Address:
								</Grid>
								<Grid
									item
									xs={12} sm={10}
									className={classes.infoContent}
								>
									{supplier.address || "Address"}
								</Grid>
							</Grid>
						</div>
						<PurchaseOrderInfoTable items={items} setItems={setItems} deleteItem={deleteItem}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Shipping: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(shipTotal).format('0,0.00')}	
									</div>							
								</div>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(poTotal).format('0,0.00')}	
									</div>
								</div>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(parseFloat(shipTotal)+parseFloat(poTotal)).format('0,0.00')}	
									</div>
								</div>
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							onChange={(e)=>{setNotes(e.target.value)}}
						/>
					</CardContent>
				</Card>
				<div className={classes.buttonContainer}>
					{/* <Button variant="contained">Back</Button> */}
					<ColorButton disabled={btnDisabled} variant="contained" color="primary" onClick={save_po_return}
					classes={{
						root: classes.root, 
							disabled: classes.disabled}}>
						Save
					</ColorButton>
				</div>
			</div>
		) : (<Preloader />)}

		</div>
	);
};

export default PurchaseOrderReturnInformation;
